import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomerForm } from './customer-form/customer-form.component'
import { Customer } from './customer.schema'

export enum CustomerFormPartType {
  BASIC = 'BASIC',
  DELIVERY = 'DELIVERY',
}

interface CustomerEditProps extends ModalProps {
  customer: Customer
  formPartType?: CustomerFormPartType
  onCancel: () => void
}

export const CustomerEdit: React.FC<CustomerEditProps> = ({ customer, formPartType, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { run: updateCustomer, loading } = useRequest(
    (data) => ({
      url: `/api/customer/patch/${customer.selfId}`,
      method: 'patch',
      data,
    }),
    {
      manual: true,
      onSuccess: () => {
        props.onCancel()
      },
    }
  )

  return (
    <Modal
      destroyOnClose
      width={'80%'}
      maskClosable={false}
      title={`${t('edit')}：${customer.name}`}
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form?.submit()}
      {...props}
    >
      {customer && (
        <CustomerForm form={form} formPartType={formPartType} customer={customer} onSubmit={updateCustomer} />
      )}
    </Modal>
  )
}
